import { Component, OnInit } from '@angular/core';
import { Paquete } from 'app/models/paquete-model';
import { Services } from 'app/servicios.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-paquetes',
  templateUrl: './paquetes.component.html',
  styleUrls: ['./paquetes.component.css']
})
export class PaquetesComponent implements OnInit {

  public paquetes : Array<Paquete>;
  public loading : boolean;
  public grupoID: Number;
  private cantPaquetes = 21;
  constructor(public API : Services, public location: Location) { }

  ngOnInit(): void {
    this.loading = true;
    var tittle = this.location.prepareExternalUrl(this.location.path());
    tittle = tittle.replace('/destinos/', '');
    this.grupoID = Number.parseInt(tittle);
    this.API.getPaquetes().subscribe(data => {
      this.paquetes = data;
      this.paquetes = this.paquetes.filter(p => p.Grupo.GrupoId == this.grupoID);
      this.loading = false;
    });
  }

  masPropiedades(){
    this.cantPaquetes += 21;
  }

  botonCargarMas(){
    if(this.cantPaquetes < this.paquetes.length){
      return true;
    }else{
      return false;
    }
  }
}
